import { render } from "./ReviewAnswers.vue?vue&type=template&id=c6eee018"
import script from "./ReviewAnswers.vue?vue&type=script&lang=js"
export * from "./ReviewAnswers.vue?vue&type=script&lang=js"

import "./ReviewAnswers.vue?vue&type=style&index=0&id=c6eee018&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__